
import React, { Fragment, useContext, useState } from 'react';
import AppContext from '../../context/app/appContext';
import Tags from '../../components/Tags/Tags';
import Selects from '../../components/Selects/Selects';
import Orderby from '../../components/Filters/Orderby';

const Filters = () => {
  const {
    postType,
    taxonomies,
    searchPosts,
    translations,
    foundPosts,
    baseUrl,
    params,
    queryParams
  } = useContext(AppContext);

  let tags = [];
  let selects = [];

  if(!taxonomies) {
    return null;
  }

  const {
    searchStr,
  } = queryParams;

  const [ searchTxt, setSearchTxt ] = useState(searchStr);
  const [ collapseClass, setCollapseClass ] = useState('d-none');
  const [ activeClass, setActiveClass ] = useState('');

  const onSubmit = e => {
    e.preventDefault();

    if(searchTxt === '') {
      searchPosts('');
    } else {
      searchPosts(searchTxt);
    }

    handlePushState();
  }

  const onChange = e => {
    if(typeof e.nativeEvent.data === 'undefined') {
      searchPosts('');
      setSearchTxt('');
    } else {
      setSearchTxt(e.target.value);
    }
    handlePushState();
  }

  const onKeyUp = e => {
    if(e.target.value === '') {;
      searchPosts('');
    }
    handlePushState();
  }

  const onCollapseClick = () => {
    setCollapseClass(collapseClass === 'd-block' ? 'd-none' : 'd-block');
    setActiveClass(activeClass === '' ? ' state-active' : '');
  };

  const handlePushState = () => {
    const formData = params || {};
    let formDataForUrl = {};
    let url = '';

    for (const key in formData) {
      const value = formData[key];

      if ([] === value) {
        continue;
      }

      const taxKey = key.replace('-', '_');
      formDataForUrl[taxKey] = value;
    }

    formDataForUrl = Object.entries(formDataForUrl).filter(
      ([key, value]) => value.length > 0
    );

    if (formDataForUrl.length !== 0) {
      const data = new URLSearchParams(formDataForUrl);
      url = `?${decodeURIComponent(data.toString())}`;
    } else {
      url = '';
    }
    window.history.pushState(params, document.title, `${baseUrl}${url}`);
  };

  tags = taxonomies.map((taxonomy, i) => {
    return(
      <Fragment key={i}>
        {taxonomy.settings.name === 'toolbox-tags' &&
          <Tags taxonomy={taxonomy}/>
        }
      </Fragment>
    );
  });

  selects = taxonomies.map((taxonomy, i) => {
    return(
      <Fragment key={i}>
        {taxonomy.settings.name !== 'toolbox-tags' &&
          <Selects taxonomy={taxonomy}/>
        }
      </Fragment>
    );
  });

  return(
    <div className="js-component-archive-filters component-archive-filters">
      <form className="component-archive-filter-form" onSubmit={onSubmit}>

        {tags}

        <div className="row d-none d-sm-flex">

          <div className={`mb-2 my-sm-2 my-md-0 ${postType === 'asset' ? 'col-12 col-sm-12 col-md-4' : 'col-12 col-sm-6 col-md-3'}`}>
            <div className="position-relative">
              <input
                type="search"
                name="search"
                className="component-archive-filter-search-input"
                placeholder={translations.search}
                value={searchTxt}
                onChange={onChange}
                onKeyUp={onKeyUp}
              />
              <button
                className="component-archive-filter-search-submit"
              >
                <i className="icon-search"></i>
              </button>
            </div>
          </div>

          {selects}

        </div>

        <div className="d-block d-sm-none mb-2">
          <div className="position-relative">
            <input
              type="text"
              name="search"
              className="component-archive-filter-search-input"
              placeholder={translations.search}
              value={searchTxt}
              onChange={onChange}
              onKeyUp={onKeyUp}
            />
            <button
              className="component-archive-filter-search-submit"
            >
              <i className="icon-search"></i>
            </button>
          </div>
        </div>

        <div className={`d-block d-sm-none filter-collapsed`}>
          <div className="filter-collapsed--inner p-3">

            <button className={`col-12 text-left filter-collapsed--trigger filter-label color-primary${activeClass}`} onClick={onCollapseClick}>
              <i className="icon-filter filter d-inline-block mr-2"></i>
              {translations.filter}
              <i className="icon-arrow-down arrow"></i>
            </button>

            <div className={collapseClass}>
              <div className="row mt-2">
                {selects}
              </div>
            </div>

          </div>
        </div>

        <div className="d-flex align-items-center justify-content-between component-archive-filter-actions mt-3 mb-4 mb-md-5">
            <div className="found-posts flex-grow-1">
              {foundPosts &&
                <p className="short-texts">{`${translations.showing} ${foundPosts} ${translations.results}`}</p>
              }
            </div>
            <Orderby />
        </div>

      </form>
    </div>
  )
}

export default Filters;



// WEBPACK FOOTER //
// ./src/components/Filters/Filters.js